import { createStore } from "vuex";
import getters from "./getters";
import auth from "./modules/auth.js";
import notify from "./modules/notify.js";

import constants from "./modules/constants.js";
import financial from "./modules/financial.js";
import permission from "./modules/permission.js";
import settings from "./modules/settings.js";
import tagsView from "./modules/tagsView.js";
import user from "./modules/user.js";
export const store = createStore({
  modules: {
    auth,
    notify,
    constants,
    financial,
    permission,
    settings,
    tagsView,
    user
  },
  getters
});
